<template>
  <a-modal
      class="cost-page"
      centered
      :title="`巨量媒体小程序资产列表 (${model.name})`"
      :width="'85%'"
      :mask-closable="false"
      :visible="showWechatAppForm"
      :confirmLoading="loading"
      :bodyStyle="{ padding: 0 }"
      :footer="null"
      @cancel="close"
  >
    <a-layout id="layout">
      <div class="search-wrapper">
        <a-space>
          <a-button type="primary" @click="search">查询</a-button>
          <a-button @click="pullWechatApp(1)" type="danger" icon="cloud" v-if="accessTo('pullWechatApp')">手动拉取微信小程序资产</a-button>
          <a-button @click="pullWechatApp(2)" style="color:orange" icon="cloud" v-if="accessTo('pullWechatApp')">手动拉取字节小程序资产</a-button>
          <a-button @click="createApp()" type="primary" icon="plus" v-if="accessTo('createApp')">创建小程序资产</a-button>
        </a-space>
      </div>

      <a-layout-content id="layout-content">
        <a-table
            size="small"
            :columns="columns"
            :row-key="record => record.id"
            :data-source="data"
            :pagination="pagination"
            :loading="loading"
            :transform-cell-text="$helper.emptyFormat"
            @change="handleTableChange"
        >

        <template slot="audit_status" slot-scope="audit_status">
          <a-tag color="green" v-if="audit_status == 'AUDIT_ACCEPTED'">审核成功</a-tag>
          <a-tag color="red" v-else-if="audit_status == 'AUDIT_REJECTED'">审核失败</a-tag>
          <a-tag color="orange" v-else>审核中</a-tag>
       </template>

        </a-table>
      </a-layout-content>
    </a-layout>


    <create-app-form
    v-if="showAppForm"
    :showAppForm.sync="showAppForm"
    :model="model"
    @success="refresh"
  />


  </a-modal>

  
</template>

<style lang="less" scoped>
@import 'Wechatapps';
</style>

<script>
import Wechatapps from './Wechatapps'

export default Wechatapps
</script>

